import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';
import { ScrollArea } from './ui/scroll-area';
import { Calendar, Globe, Award, CreditCard, Hash, User, Clock, FileText, MapPin, Mail, Phone } from 'lucide-react';

const RecordDetailModal = ({ record, open, onClose }) => {
  if (!record) return null;

  const fields = [
    { label: 'Date', value: record.date, icon: Calendar, color: 'text-blue-600' },
    { label: 'Time', value: record.time, icon: Clock, color: 'text-purple-600' },
    { label: 'Website', value: record.website, icon: Globe, color: 'text-emerald-600' },
    { label: 'Offer', value: record.offer, icon: Award, color: 'text-orange-600' },
    { label: 'Credit Score', value: record.credit_score, icon: CreditCard, color: 'text-red-600' },
    { label: 'Verification ID', value: record.verification_id, icon: Hash, color: 'text-indigo-600' },
    { label: 'First Name', value: record.first_name, icon: User, color: 'text-pink-600' },
    { label: 'Last Name', value: record.last_name, icon: User, color: 'text-pink-600' },
    { label: 'Agent', value: record.agent, icon: User, color: 'text-teal-600' },
    { label: 'Email', value: record.email, icon: Mail, color: 'text-blue-600' },
    { label: 'Phone', value: record.phone, icon: Phone, color: 'text-green-600' },
    { label: 'Address', value: record.address, icon: MapPin, color: 'text-red-600' },
    { label: 'City', value: record.city, icon: MapPin, color: 'text-orange-600' },
    { label: 'State', value: record.state, icon: MapPin, color: 'text-purple-600' },
    { label: 'Zipcode', value: record.zipcode, icon: MapPin, color: 'text-blue-600' },
    { label: 'Reason', value: record.reason, icon: FileText, color: 'text-slate-600' },
  ];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[85vh]" data-testid="record-detail-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">
            Record Details
            <Badge variant="outline" className="ml-3 font-mono text-xs">
              ID: {record.id}
            </Badge>
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[calc(85vh-120px)] pr-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {fields.map((field, index) => {
              const Icon = field.icon;
              return (
                <div
                  key={index}
                  className="p-4 bg-slate-50/50 rounded-lg border border-slate-100 hover:border-slate-200 transition-all"
                  data-testid={`detail-field-${index}`}
                >
                  <div className="flex items-start gap-3">
                    <div className="mt-0.5">
                      <Icon className={`w-4 h-4 ${field.color}`} strokeWidth={1.5} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-medium text-muted-foreground mb-1">{field.label}</p>
                      <p className="text-sm font-semibold text-primary break-words">
                        {field.value || 'N/A'}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-4 p-4 bg-blue-50/50 rounded-lg border border-blue-100">
            <p className="text-xs text-muted-foreground">
              Created: {new Date(record.created_at).toLocaleString()}
            </p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default RecordDetailModal;